import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.RESET_LOGIN](state) {
    state.roles = null
    state.token = null
    state.username = null
    storage.session.clear()
  },
  [types.SET_TOKEN](state, data) {
    state.token = data
    storage.session.setItem(types.SESSION_TOKEN_NAME, data)
  },
  [types.SET_ROLES](state, profile) {
    state.primaryRole = ''
    if (profile && profile.Roles && profile.Roles.length) {
      let roles = profile.Roles.map(r => r.Name)
      state.roles = roles
      storage.session.setItem(types.SESSION_ROLES_NAME, JSON.stringify(roles))
      for (let role of roles) {
        if (role === 'InShopTech' || role === 'DiagCoord') {
          state.primaryRole = 'Tech'
          break
        } else if (role === 'MasterTech') {
          state.primaryRole = 'MasterTech'
          break
        } else if (role === 'ReviewTech') {
          state.primaryRole = 'ReviewTech'
          break
        } else if (role === 'Dispatch') {
          state.primaryRole = 'Dispatch'
          break
        } else if (role === 'LeadTech') {
          state.primaryRole = 'LeadTech'
          break
        } else if (role === 'SuperAdmin') {
          state.primaryRole = 'SuperAdmin'
          break
        } else if (role === 'Admin') {
          state.primaryRole = 'Admin'
          break
        } else if (role === 'Leadership') {
          state.primaryRole = 'Leadership'
          break
        } else if (role === 'Manager') {
          state.primaryRole = 'Manager'
          break
        } else if (role === 'Shop Admin') {
          state.primaryRole = 'Shop Admin'
          break
        } else if (role === 'Shop User') {
          state.primaryRole = 'Shop User'
          break
        } else if (role === 'Mobile') {
          state.primaryRole = 'Mobile'
          break
        }
      }
      if (state.primaryRole === '') {
        state.primaryRole = roles[0]
      }
    }
    storage.session.setItem(
      types.SESSION_PRIMARY_ROLE,
      JSON.stringify(state.primaryRole)
    )
    state.userProfile = null
    state.phoneExtension = profile.PhoneExtension
    state.phoneNumber = profile.PhoneNumber
    console.log('SET_ROLES state', state, 'profile', profile)
    console.log(profile)
    if (profile) {
      state.userProfile = {
        id: profile.TeamMemberId,
        location: profile.Location,
        timeZone: profile.TimeZone,
        firstName: profile.GivenName,
        lastName: profile.FamilyName,
        userName: profile.Username,
        email: profile.Email,
        primaryRole: state.primaryRole,
        phoneNumber: profile.PhoneNumber,
        phoneExtension: profile.PhoneExtension
      }
      storage.session.setItem(
        types.SESSION_USER_PROFILE,
        JSON.stringify(state.userProfile)
      )
      console.log(state.userProfile)
    }
  },
  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js